import {
    APP_SET_SHOW_SETTINGS_STATE,
    APP_SET_SHOW_LOGIN_STATE,
    APP_SET_AUTOLAUNCH_ENABLED_STATE,
} from '../constants'

const appInitialState = {
    showSettings: false,
    showLogin: false,
    autoRunEnabled: true,
}

export default function app(state = appInitialState, action) {
    switch (action.type) {
        case APP_SET_SHOW_SETTINGS_STATE: {
            return {
                ...state,
                showSettings: action.payload,
            }
        }

        case APP_SET_SHOW_LOGIN_STATE: {
            return {
                ...state,
                showLogin: action.payload,
            }
        }

        case APP_SET_AUTOLAUNCH_ENABLED_STATE: {
            return {
                ...state,
                autoRunEnabled: action.payload,
            }
        }

        // Do nothing
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/reducers/app.js